import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "outRelations",
  "use": "outRelations-usage",
  "viewBox": "0 0 19.64 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19.64 18\" id=\"outRelations\"><title>外部关系</title><path d=\"M13.23 10.5a.44.44 0 0 0-.55 0 4.36 4.36 0 0 1-5.73 0 .42.42 0 0 0-.53 0 4.37 4.37 0 0 1-4.29.83c-.07 0-.17 0-.17-.07v4.91a1.85 1.85 0 0 0 2 1.85h11.71a1.91 1.91 0 0 0 2.06-1.87v-4.91a4.36 4.36 0 0 1-4.53-.74zm-6.26 6.43a.44.44 0 0 1-.88 0v-5a.44.44 0 0 1 .88 0z\" /><path d=\"M19.52 6.35v-.12L16.89.94A1.69 1.69 0 0 0 15.38 0H4.2a1.67 1.67 0 0 0-1.47.94L.15 6.24v.11a3 3 0 0 0-.11.83A3.55 3.55 0 0 0 6.4 9.35a.42.42 0 0 1 .65 0 3.54 3.54 0 0 0 5.62 0 .41.41 0 0 1 .65 0 3.55 3.55 0 0 0 3.41 1.33 3.75 3.75 0 0 0 2.87-3.63 4.8 4.8 0 0 0-.08-.7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/outRelations.svg
// module id = mVBQ
// module chunks = 6